import { useFormikContext } from 'formik';
import { useCheckoutState } from '../../utils/checkoutState';
import useAdyen, { AdyenConfig, AdyenParams } from '../../utils/useAdyen';

// https://docs.adyen.com/payment-methods/online-banking-poland/web-component
const AdyenOnlineBankingPlPayment = ({ isSPAY }: { isSPAY?: boolean }) => {
  const { adyenSpecificationPayloadRef } = useCheckoutState();
  const { setFieldValue } = useFormikContext<{ paymentMethod: string }>();

  const adyenConfig: AdyenConfig = {
    withPspSession: isSPAY,
    onChange: ({ isValid, data: { paymentMethod, origin, browserInfo } }: AdyenParams) => {
      adyenSpecificationPayloadRef.current = { paymentMethod, origin, browserInfo };
      setFieldValue('adyenOnlineBankingPl', { isValid });
    }
  };

  const AdyenOnlineBankingPlComponent = useAdyen({ name: 'onlineBanking_PL', adyenConfig, withActions: true });
  return <div className="option__form">{AdyenOnlineBankingPlComponent}</div>;
};

export default AdyenOnlineBankingPlPayment;
